import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { dispatch, useGlobalState } from '../../store/state';
import { Col, message, Result, Skeleton } from 'antd';
// import {
//     MenuUnfoldOutlined,
//     MenuFoldOutlined,
//     UserOutlined,
//     VideoCameraOutlined,
//     UploadOutlined,
//   } from '@ant-design/icons';
import './InfluencerHomePage.styles.scss';
import InfluencerTopSubHeaderComponent from '../../components/Influencers/Common/InfluencerTopSubHeaderComponent';
import InfluencerBaseLayoutComponent from '../../components/Layout/Influencer/InfluencerBaseLayoutComponent';
import ProfileBasicComponent from '../../components/Influencers/Home/ProfileBasicComponent';
import ProfileEarnStatsComponent from '../../components/Influencers/Home/ProfileEarnStatsComponent';
import { GetProfileDetails } from '../../apis/Influencer/Profile/GetProfileDetails';
import { GetInstaPosts } from '../../apis/Influencer/Profile/GetInstaPosts';
import { getInstaFollowerChangeApi, getInstaFollowerGenderAndAgeApi } from '../../apis/Influencer/Profile/getInstaFollowerChangeApi';
import { getInstaFollowerCity, getInstaFollowerCountry } from '../../apis/Influencer/Profile/getInstaFollowerLocationStats';
import { getInstaReachStats } from '../../apis/Influencer/Profile/getInstaReachStats';
import { FaInstagram, FaTwitter, FaYoutube } from 'react-icons/fa';
import ProfileAboutComponent from '../../components/Influencers/Profile/ProfileAboutComponent';
import EmptyInfluencerComponent from '../../components/Brand/InfluencerList/EmptyInfluencerComponent';
import SocialPostComponent from '../../components/Influencers/Profile/SocialPostComponent';
import FollowerStatsComponent from '../../components/Influencers/Campaign/Details/FollowersStatsComponent';
import ReachStatsComponent from '../../components/Influencers/Campaign/Details/ReachStatsComponent';
import ImpressionsStatsComponent from '../../components/Influencers/Campaign/Details/ImpressionsStatsComponent';
import AudienceAgeStatsComponent from '../../components/Influencers/Campaign/Details/AudienceAgeStatsComponent';
import AudienceGenderStatsComponent from '../../components/Influencers/Campaign/Details/AudienceGenderStatsComponent';
import AudienceCountryStatsComponent from '../../components/Influencers/Campaign/Details/AudienceCountryStatsComponent';
import AudienceCityStatsComponent from '../../components/Influencers/Campaign/Details/AudienceCityStatsComponent';


// const { Header, Sider, Content } = Layout;
export const InfluencerStatsPage = () => {
  const [user] = useGlobalState('user');
  const [loading, setLoading] = useState(true);
  const [post, setPost] = useState([]);
  const [followersChnage, setFollowersChnage] = useState([]);
  const [reachStats, setReachStats] = useState([]);
  const [impressionsStats, setImpressionsStats] = useState([]);
  const [genderStats, setGenderStats] = useState([]);
  const [ageStats, setAgeStats] = useState([]);
  const [cityStats, setCityStats] = useState([]);
  const [countryStats, setCountryStats] = useState([]);

  const topPosts = post.sort((a, b) => {
    return ((b.like_count+b.comments_count) - (a.like_count+a.comments_count));
  }) || [];

  const recentPosts = post.sort((a, b) => {
    return new Date(b.timestamp) - new Date(a.timestamp);
  }) || [];

  const getInstaFollowerChange = async () => {
    getInstaFollowerChangeApi(user.accessToken).then((res) => {
      if (res.status === 200) {
        let data = res.response.data;
        data = data.map((item) => {
          item.date = moment(item.end_time).format('MMM DD, YYYY');
          return item;
        });
        setFollowersChnage(data);
      }
    });
  };

  const getInstaReach = async () => {
    getInstaReachStats(user.accessToken).then((res) => {
      if (res.status === 200) {
        const data = res.response.data;
        let reach = data.reach;
        console.log({ reach });
        let impressions = data.impressions;
        reach = reach.map((item) => {
          item.date = moment(item.end_time).format('MMM DD, YYYY');
          return item;
        });
        impressions = impressions.map((item) => {
          item.date = moment(item.end_time).format('MMM DD, YYYY');
          return item;
        });
        setImpressionsStats(impressions);
        setReachStats(reach);
      }
    });
  };

  const getInstaFollowerGenderAndAge = async () => {
    getInstaFollowerGenderAndAgeApi(user.accessToken).then((res) => {
      if (res.status === 200) {
        const data = res.response.data[0].value;
        const genderStat = Object.keys(data).reduce((acc, key) => {
          if (key[0] === 'F') {
            return { ...acc, female: acc.female + data[key] };
          } else if (key[0] === 'M') {
            return { ...acc, male: acc.male + data[key] };
          } else {
            return { ...acc, unknown: acc.unknown + data[key] };
          }
        }, {
          'male': 0,
          'female': 0,
          'unknown': 0,
        });
        setGenderStats([
          {
            type: 'Male',
            value: genderStat.male || 0,
          },
          {
            type: 'Female',
            value: genderStat.female || 0,
          },
          {
            type: 'Unknown',
            value: genderStat.unknown || 0,
          },
        ]);

        // Get Age Group

        // {
        //   'name': 'Female',
        //   'ageGroup': '55-64',
        //   'value': 35.5,
        // },
        const ageGroup = Object.keys(data).map((key) => {
          if (key[0] === 'F') {
            return {
              name: 'Female',
              ageGroup: key.slice(2),
              value: data[key],
            };
          } else if (key[0] === 'M') {
            return {
              name: 'Male',
              ageGroup: key.slice(2),
              value: data[key],
            };
          } else {
            return {
              name: 'Unkown',
              ageGroup: key.slice(2),
              value: data[key],
            };
          }
        });
        setAgeStats(ageGroup);
      }
    });
  };

  const getInstaPosts = async () => {
    GetInstaPosts(user.accessToken).then((res) => {
      if (res.status === 200) {
        setPost(res.response.data);
        setLoading(false);
      }
    }).catch((err) => {
      console.log(err);
    });
  };

  const getInstaFollowerCityStats = async () => {
    getInstaFollowerCity(user.accessToken).then((res) => {
      if (res.status === 200) {
        const data = res.response.data[0].value;
        const cityStats = Object.keys(data).map((key) => {
          return {
            name: key,
            value: data[key],
          };
        });
        setCityStats(cityStats.sort((a, b) => b.value - a.value));
      }
    }).catch((err) => {
      console.log(err);
    });
  };

  const getInstaFollowerCountryStats = async () => {
    getInstaFollowerCountry(user.accessToken).then((res) => {
      if (res.status === 200) {
        const data = res.response.data[0].value;
        const cityStats = Object.keys(data).map((key) => {
          return {
            name: key,
            value: data[key],
          };
        });
        setCountryStats(cityStats.sort((a, b) => b.value - a.value));
      }
    }).catch((err) => {
      console.log(err);
    });
  };
  const getProfileData = () =>{
    GetProfileDetails(user.accessToken).then(({ response, status }) =>{
      console.log('getting data', response);
      if (status === 200) {
        dispatch({
          type: 'SET_USER',
          payload: {
            ...user,
            ...response,
          },
        });
        setLoading(false);
      } else {
        message.error('There is some issue with getting your profile details');
      }
    });
  };

  const renderPlatform = (platform)=>{ // render platform icons
    switch (platform) {
    case 'youtube': return <FaYoutube/>;
    case 'instagram': return <FaInstagram/>;
    case 'twitter': return <FaTwitter/>;
    default: return null;
    }
  };

  // const getCampiagnList = (type,page) =>{
  //     CampaignList(
  //         user.accessToken,
  //         {type:type,page:page}
  //     ).then(({status,response})=>{
  //         console.log("retrived Data in influ",response)
  //         if(status === 200){
  //             setCampList({
  //                 ...campList,
  //                 ...response
  //             })
  //             setCampLoading(false)
  //         }else{
  //             message.error("There is some error in getting Campaign list")
  //         }
  //     })
  // }
  useEffect(()=>{
    getProfileData();
    getInstaPosts();
    getInstaFollowerChange();
    getInstaReach();
    getInstaFollowerGenderAndAge();
    getInstaFollowerCityStats();
    getInstaFollowerCountryStats();
    // getCampiagnList();
  }, []);


  return (
    <InfluencerBaseLayoutComponent>
      <InfluencerTopSubHeaderComponent className="p-3 sticky">
        <h6 className="m-0">Hello {user.firstname}</h6>
      </InfluencerTopSubHeaderComponent>
      <div className="d-flex flex-wrap px-2">
        <ProfileBasicComponent
          loading={loading}
          picture={user?.picture || user?.profilepicture}
          firstname={user?.firstname}
          lastname={user?.lastname}
          gender={user?.gender}
          id={user?.id}
          city_living={user?.address?.city}
          interests={user?.interests}
          youtube_account={user?.youtube_account}
          twitter_account={user?.twitter_account}
          instagram_account={user?.instagram_account}

        />
        <ProfileEarnStatsComponent
          loading={loading}
          platformData={{
            youtube: user?.youtube_account,
            twitter: user?.twitter_account,
            instagram: user?.instagram_account,
          }}
        />
        {/* camp stats */}
        <ProfileAboutComponent loading={loading}/>
        {
          user?.instagram_account?.enabled ? (
            <>
              <div className="col-md-12">
                <div className="common_card mt-3 over_progress_multi p-3">
                  <h6 className="pb-2"><strong>Popular Posts</strong></h6>
                  <div className="d-flex pb-2"
                    style={{ justifyContent: 'space-between', minWidth: '250px', maxHeight: '350px', gap: 20, overflowX: 'scroll' }}>
                    {topPosts && topPosts.length ?
                      topPosts.map((post) =><SocialPostComponent post={post}/> ):
                      <EmptyInfluencerComponent>Please link your social paltform to see the popular posts.</EmptyInfluencerComponent>
                    }
                  </div>
                </div>
              </div>
              <div className="col-md-12">
                <div className="common_card mt-3 over_progress_multi p-3">
                  <h6 className="pb-2"><strong>Recent Posts</strong></h6>
                  <div className="d-flex pb-2"
                    style={{ justifyContent: 'space-between', minWidth: '250px', maxHeight: '350px', gap: 20, overflowX: 'scroll' }}>
                    {recentPosts && recentPosts.length ?
                      recentPosts.map((post) => <SocialPostComponent post={post}/> ):
                      <EmptyInfluencerComponent>Please link your social paltform to see the recent posts.</EmptyInfluencerComponent>
                    }
                  </div>
                </div>
              </div>
              <div className='col-md-12 mt-3'>
                <h5> <strong>Insights</strong></h5>
              </div>
              {
                user?.instagram_account?.enabled && user.instagram_account?.permissions?.instagram_manage_insights === 'granted' ? (
                  <>
                    <div className='col-md-6  col-sm-12'>
                      <div className="common_card mt-3 over_progress_multi p-3">
                        <FollowerStatsComponent followersChnage={followersChnage}/>
                      </div>
                    </div>
                    <div className='col-md-6  col-sm-12'>
                      <div className="common_card mt-3 over_progress_multi p-3">
                        <ReachStatsComponent reachStats={reachStats}/>
                      </div>
                    </div>
                    <div className='col-md-6  col-sm-12'>
                      <div className="common_card mt-3 over_progress_multi p-3">
                        <ImpressionsStatsComponent impressionsStats={impressionsStats}/>
                      </div>
                    </div>
                    <div className='col-md-6  col-sm-12'>
                      <div className="common_card mt-3 over_progress_multi p-3">
                        <AudienceGenderStatsComponent genderStats={genderStats} />
                      </div>
                    </div>
                    <div className='col-md-6 col-sm-12'>
                      <div className="common_card mt-3 over_progress_multi p-3">
                        <AudienceCountryStatsComponent countryStats={countryStats} />
                      </div>
                    </div>
                    <div className='col-md-6'>
                      <div className="common_card mt-3 over_progress_multi p-3">
                        <AudienceCityStatsComponent cityStats={cityStats}/>
                      </div>
                    </div>
                    <div className='col-md-12'>
                      <div className="common_card mt-3 over_progress_multi p-3">
                        <AudienceAgeStatsComponent ageStats={ageStats}/>
                      </div>
                    </div>
                  </>
                ): (
                  <EmptyInfluencerComponent>You have not granted instagram_manage_insights permissions, Please grant all required permissions from Facebook App or unlink and link again with all permissions. Thanks !!</EmptyInfluencerComponent>
                )
              }
            </>
          ) : (
            <EmptyInfluencerComponent>Please link your social paltform to see the stats.</EmptyInfluencerComponent>
          )
        }


      </div>
    </InfluencerBaseLayoutComponent>
  );
};
